export { WavelengthCreator } from './wavelength.creator';
export { WAVELENGTH_DEFAULTS, WAVELENGTH_DEFAULT_PARAMS, type WavelengthParams } from './wavelength.model';
